var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-alert',{staticClass:"h-full my-4",attrs:{"icon-pack":"feather","icon":"icon-info","color":"warning"}},[_c('span',[_vm._v("Ha ocurrido un error mientras se obtenían los datos. Lamentamos el inconveniente. "),_c('a',{staticClass:"underline bold black",attrs:{"href":"#"},on:{"click":_vm.reload}},[_vm._v("Intenta recargando la página.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }